import { Paper, FormControl, Select, MenuItem, InputLabel, Grid, useTheme, Chip, Box, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CouponTemplateStatus } from "../../store/models/coupon/CouponManagementDto";
import ImsPaperHead from "../atoms/ImsPaperHead";

interface CouponFiltersProps {
  searchTerm: string;
  statusFilter: string[];
  onSearchChange: (searchTerm: string) => void;
  onStatusChange: (statuses: string[]) => void;
}

const CouponFilters = ({ searchTerm, statusFilter, onSearchChange, onStatusChange }: CouponFiltersProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Paper
      style={{
        padding: theme.spacing(3, 3, 6, 3),
        margin: theme.spacing(6, 0, 3, 0),
      }}
    >
      <ImsPaperHead text={t("coupon.searchTitle")} />
      <Grid container spacing={4}>
        <Grid container spacing={2} item>
          <Grid item xs={12} sm={6} lg={3}>
            <TextField
              fullWidth
              label={t("coupon.table.searchPlaceholder")}
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <FormControl fullWidth>
              <InputLabel>{t("coupon.statusFilter")}</InputLabel>
              <Select
                multiple
                value={statusFilter}
                onChange={(e) => onStatusChange(typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value)}
                label={t("coupon.statusFilter")}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={t(`coupon.status.${value.toLowerCase()}`)}
                        size="small"
                      />
                    ))}
                  </Box>
                )}
              >
                <MenuItem value={CouponTemplateStatus.ACTIVE}>
                  {t("coupon.status.active")}
                </MenuItem>
                <MenuItem value={CouponTemplateStatus.DRAFT}>
                  {t("coupon.status.draft")}
                </MenuItem>
                <MenuItem value={CouponTemplateStatus.INACTIVE}>
                  {t("coupon.status.inactive")}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CouponFilters;
